/**
 * @generated SignedSource<<46a077dd94f46642e7d28ef87e3ee634>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileEdition_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unconfirmedEmail",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileEditionForm_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

node.hash = "3d7e07900b1db5deba0babbdab2d9c16";

module.exports = node;
